import { type CSSProperties, type ReactNode } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { CloseIcon, PlusIconBlack } from "@/shared/assets/svg/icons";

interface FilterDatePickerProps {
  filterLabel: string;
  getFilterValue: (filterLabel: string) => string | dayjs.Dayjs | undefined;
  getFilterStyle: (filterLabel: string) => CSSProperties;
  handleFilterChange: (filterLabel: string, dateString: string) => void;
  getFilterIcon: (
    filterLabel: string,
    clearIcon: ReactNode,
    plusIcon: ReactNode,
  ) => ReactNode;
}

export function FilterDatePicker({
  filterLabel,
  getFilterValue,
  getFilterStyle,
  handleFilterChange,
  getFilterIcon,
}: FilterDatePickerProps) {
  const value = getFilterValue(filterLabel);
  const style = {
    width: "16px",
    height: "16px",
    fontSize: "16px",
  };
  return (
    <DatePicker
      placeholder={filterLabel}
      value={value && dayjs.isDayjs(value) ? value : null}
      style={{
        ...getFilterStyle(filterLabel),
        minWidth: "150px",
      }}
      format="DD.MM.YYYY"
      allowClear={{
        clearIcon: <CloseIcon style={style} />,
      }}
      suffixIcon={getFilterIcon(
        filterLabel,
        <CloseIcon style={style} />,
        <PlusIconBlack style={style} />,
      )}
      onChange={(date) => {
        handleFilterChange(filterLabel, date ? date.format("DD.MM.YYYY") : "");
      }}
    />
  );
}
